<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#005f32" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-layout wrap justify-start v-if="position === '62a2de91ecd959516cd3b0e6'">
        <v-flex xs12>
          <v-layout wrap justify-end>
            <v-flex text-right xs12 sm6 md4 lg4 xl4 px-2 pt-4 pt-sm-0 pt-md-0 pt-lg-0 pt-xl-0>
              <v-select v-model="selectedFilter" class="rounded-xl" :items="filterOptions" label="Filter by" dense
                clearable outlined></v-select>
            </v-flex>

            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="presentDialog = true" style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Total Present</div>
                        <div class="itemHeading" style="color: #005f32">{{ dashboard.presentCount }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-account-multiple-plus-outline
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <!-- <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Total Absent</div>
                        <div class="itemHeading" style="color: #005f32">{{ dashboard.absentCount }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-account-multiple-minus-outline
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex> -->

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="onLeaveDialog = true" style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Total On Leave</div>
                        <div class="itemHeading" style="color: #005f32">{{ dashboard.leaveCount }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-account-multiple-remove-outline
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="onTimeDialog = true" style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Employees On Time</div>
                        <div class="itemHeading" style="color: #005f32">{{ onTimeArrivals }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-timer-alert-outline
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="lateDialog = true" style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Late Arrival</div>
                        <div class="itemHeading" style="color: #005f32">{{ lateArrivals }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-history
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="workAnniversaryDialog = true"
                    style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Work Anniversaries</div>
                        <div class="itemHeading" style="color: #005f32">{{ workAnniversary.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-party-popper
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="birthdayDialog = true" style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Employee Birthdays</div>
                        <div class="itemHeading" style="color: #005f32">{{ birthdayList.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-cake-variant-outline
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="latestEmployeeDialog = true"
                    style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Newly Joined Employees</div>
                        <div class="itemHeading" style="color: #005f32">{{ latestEmployeeList.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-account-multiple-plus
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="lastResignedDialog = true"
                    style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Last Resigned Employees</div>
                        <div class="itemHeading" style="color: #005f32">{{ lastResignedList.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-account-multiple-minus
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>


                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="milestoneDialog = true"
                    style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Milestones</div>
                        <div class="itemHeading" style="color: #005f32">{{ milestones.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-trophy
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="importantDatesDialog = true"
                    style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div>Important Dates</div>
                        <div class="itemHeading" style="color: #005f32">{{ importantDates.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-calendar-star
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md4 lg4 pa-2>
                  <v-card class="pa-6 elevation-1" rounded="lg" @click="upcomingProbationDialog = true"
                    style="cursor: pointer;">
                    <v-layout wrap justify-start align-center>
                      <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                        <div class="text-truncate" title="Upcoming Probation Review">Upcoming Probation Review</div>
                        <div class="itemHeading" style="color: #005f32">{{ upcomingProbationClearanceList.length }}</div>
                      </v-flex>
                      <v-flex xs2 sm3 md3 lg3 text-center>
                        <v-icon color="#005f32" size="50px">
                          mdi-account-clock
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout wrap pb-5>
          <v-flex xs12 sm12 md6 lg6>
            <v-layout wrap pb-5>
              <v-flex xs12 py-6 class="itemHeading">
                Employee Probation Status
              </v-flex>
              <v-flex xs12 class="graph" pl-2>
                <v-card color="#fafcfb" elevation="2" class="pa-3">
                  <v-layout row wrap align-center px-3 pt-8>
                    <v-flex xs12>
                      <div id="probation-chart" v-if="probationFlag">
                        <apexchart type="bar" height="400" :options="probationChartOptions" :series="probationSeries">
                        </apexchart>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-layout wrap pb-5>
              <v-flex xs12 py-6 class="itemHeading">
                Employee Age Distribution
              </v-flex>
              <v-flex xs12 class="graph" pl-2>
                <v-card color="#fafcfb" elevation="2" class="pa-3">
                  <v-layout row wrap align-center px-3 pt-8>
                    <v-flex xs12>
                      <div id="age-distribution-chart" v-if="ageDistributionFlag">
                        <apexchart ref="ageChart" type="bar" height="400" :options="ageDistributionChartOptions"
                          :series="ageDistributionSeries">
                        </apexchart>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap pb-5>
          <v-flex xs12 sm12 md6 lg6>
            <v-layout wrap pb-5>
              <v-flex xs12 py-6 class="itemHeading">
                Employee Gender Distribution
              </v-flex>
              <v-flex xs12 class="graph" pl-2>
                <v-card color="#fafcfb" elevation="2" class="pa-3">
                  <v-layout row wrap align-center px-3 pt-8>
                    <v-flex xs12>
                      <div id="gender-distribution-chart" v-if="genderDistributionFlag">
                        <apexchart type="bar" height="400" :options="genderDistributionChartOptions"
                          :series="genderDistributionSeries">
                        </apexchart>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-layout wrap pb-5>
              <v-flex xs12 py-6 class="itemHeading">
                Employee Staff Distribution
              </v-flex>
              <v-flex xs12 class="graph" pl-2>
                <v-card color="#fafcfb" elevation="2" class="pa-3">
                  <v-layout row wrap align-center px-3 pt-8>
                    <v-flex xs12>
                      <div id="staff-distribution-chart" v-if="staffDistributionFlag">
                        <apexchart type="bar" height="400" :options="staffDistributionChartOptions"
                          :series="staffDistributionSeries">
                        </apexchart>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        
        <v-layout wrap pb-5>
          <v-flex xs12 py-6 class="itemHeading">
            Employee Growth Over the Years
          </v-flex>
          <v-flex xs12 class="graph" pl-2>
            <v-card color="#fafcfb" elevation="2" class="pa-3">
              <v-layout row wrap align-center px-3 pt-8>
                <v-flex xs12 sm6 md4 pr-2>
                  <v-select small v-model="selectedGrowthChunk" :items="growthChunkOptions" label="Select 5-Year Period" @change="getEmployeeGrowthGraph"
                    :hide-details="true" dense outlined class="rounded-xl">
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md4 pl-2>
                  <v-btn small color="#005f32" class="white--text" @click="pastDataDialog = true">Add Past Data</v-btn>
                </v-flex>
              </v-layout>

              <br>
              <div id="chart" v-if="flag">
                <apexchart type="bar" height="400" :options="chartOptions" :series="series">
                </apexchart>
              </div>
            </v-card>
            
            <v-dialog v-model="pastDataDialog" max-width="500px">
              <v-card>
                <v-card-title class="elevation-0" style="background-color: #005f32; color: white;">
                  <span class="text-h5" style="font-family: kumbhBold">Add Past Employee Growth Data</span>
                </v-card-title>
                <v-card-text class="pt-5">
                  <v-container>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md6 pr-2>
                        <v-text-field v-model="pastDataForm.financialYear" label="Financial Year (e.g. 1998-1999)" outlined dense></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 pl-2>
                        <v-text-field type="number" v-model="pastDataForm.count" label="Total Employee Count" outlined dense></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-1" text @click="pastDataDialog = false">Cancel</v-btn>
                  <v-btn color="#005f32" class="white--text" @click="submitPastData">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>

      </v-layout>


      <v-flex xs12 pt-5 v-if="position != '62a2de91ecd959516cd3b0e6'">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-card color="rgb(220, 252, 202)">
              <v-layout wrap pa-5 justify-center>
                <v-flex xs12 text-center py-2>
                  <span class="kumbhBold" style="font-size: 24px; color: #005f32;">
                    {{ getGreeting() }}
                  </span>
                </v-flex>
                <v-flex xs12>
                  <span style="font-family: kumbhSemibold; font-size: 20px">{{
                    currentdate
                  }}</span>
                </v-flex>
                <v-flex xs12 py-5>
                  <v-layout wrap>
                    <v-flex xs12 md8>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-btn color="#005f32" outlined rounded>
                                <span style="
                                    font-family: kumbhBold;
                                    text-transform: none;
                                  ">Punch In</span>
                              </v-btn>
                            </v-flex>
                            <v-flex xs12 pt-5 v-if="loginTime">
                              <span style="font-family: kumbhBold">{{
                                convertUTCToLocal(loginTime)
                              }}</span>
                            </v-flex>
                            <v-flex xs12 pt-5 v-else>
                              <span style="font-family: kumbhBold">Not Marked</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-btn color="#005f32" outlined rounded>
                                <span style="
                                    font-family: kumbhBold;
                                    text-transform: none;
                                  ">Punch Out</span>
                              </v-btn>
                            </v-flex>
                            <v-flex xs12 pt-5 v-if="logoutTime">
                              <span style="font-family: kumbhBold">{{
                                convertUTCToLocal(logoutTime)
                              }}</span>
                            </v-flex>
                            <v-flex xs12 pt-5 v-else>
                              <span style="font-family: kumbhBold">Not Marked</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 md4 text-center mt-3 mt-md-0 v-if="hourValue != 0">
                      <vue-ellipse-progress :progress="value1" :angle="-90" color="green" :size="100" :thickness="10"
                        :legend="false" :legendValue="0" legendClass="legend-custom-style" animation="reverse 700 400"
                        :noData="false" :loading="false" fontColor="red" :half="false" fontSize="5rem">
                        <!-- <span slot="legend-value">/200</span> -->
                        <p class="pt-5" slot="legend-caption" style="color: black; font-weight: bold">
                          {{ hourValue }} hr
                        </p>
                      </vue-ellipse-progress>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout align-center justify-start wrap>
                    <v-flex xs12 md6 text-start pb-3 pb-md-0 v-if="
                      isLoggedin == false &&
                      isLoggedout == false &&
                      profile.onLeave == false
                    ">
                      <v-btn block color="#005f32" rounded dark @click="submit('login')">
                        <span style="font-family: kumbhSemibold">Punch In</span>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 md6 text-start pb-3 pb-md-0 v-if="
                      isLoggedin == true &&
                      isLoggedout == false &&
                      profile.onLeave == false
                    ">
                      <v-btn block color="#005f32" rounded dark @click="submit('logout')">
                        <span style="font-family: kumbhSemibold">Punch Out</span>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 md6 text-start pb-3 pb-md-0 v-if="profile.onLeave == true">
                      <v-btn block color="#005f32" rounded dark>
                        <span style="font-family: kumbhSemibold">On Leave</span>
                      </v-btn>
                    </v-flex>
                    <template>
                      <v-flex xs4 md2 align-self-center text-center text-md-end v-if="
                        isLoggedin == true &&
                        isLoggedout == false &&
                        attendanceData.description
                      ">
                        <v-btn color="#005f32" rounded dark small @click="remarkdialogedit = true">
                          <span style="
                                font-family: kumbhBold;
                                text-transform: none;
                                color: white;
                              ">Notes <v-icon small> mdi-pencil </v-icon></span>
                        </v-btn>
                      </v-flex>

                      <v-flex xs4 md2 align-self-center text-center text-md-end v-if="
                        isLoggedin == true &&
                        isLoggedout == false &&
                        !attendanceData.description
                      ">
                        <v-btn color="#005f32" rounded dark small @click="remarkdialog = true">
                          <span style="
                              font-family: kumbhBold;
                              text-transform: none;
                              color: white;
                            ">Notes
                          </span>
                        </v-btn>
                      </v-flex>
                    </template>
                    <v-flex xs8 md4 align-self-center text-left pl-3 pl-md-10>
                      <v-btn outlined color="#005f32" rounded medium to="/Troubleshoot/Report"
                        style="text-transform: none; border: 1px solid #005f32 !important;">
                        <span style="font-family: kumbhSemibold; color: #005f32">Troubleshoot</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs12 sm6 text-start
                  v-if="isLoggedin == false && isLoggedout == false && profile.onLeave == false">
                  <v-btn block color="#005f32" rounded dark @click="submit('login')">
                    <span style="font-family: kumbhSemibold">Punch In</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 text-start
                  v-if="isLoggedin == true && isLoggedout == false && profile.onLeave == false">
                  <v-btn block color="#005f32" rounded dark @click="submit('logout')">
                    <span style="font-family: kumbhSemibold">Punch Out</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 text-start v-if="profile.onLeave == true">
                  <v-btn block color="#005f32" rounded dark>
                    <span style="font-family: kumbhSemibold">On Leave</span>
                  </v-btn>
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg6 pl-2>
            <v-layout wrap justify-center>
              <v-flex xs12 pl-2 pb-2>
                <v-card class="pa-6 elevation-1" rounded="lg">
                  <v-layout wrap justify-start align-center>
                    <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                      <div>My Work Anniversary</div>
                      <div class="itemHeading" style="color: #005f32">
                        {{ myWorkAnniversary.month }} {{ myWorkAnniversary.date }}
                      </div>
                    </v-flex>
                    <v-flex xs2 sm3 md3 lg3 text-center>
                      <v-icon color="#005f32" size="50px">
                        mdi-party-popper
                      </v-icon>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 pl-2 pb-2>
                <v-card class="pa-6 elevation-1" rounded="lg" @click="festivalDialog = true" style="cursor: pointer;">
                  <v-layout wrap justify-start align-center>
                    <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                      <div>Upcoming Holidays</div>
                      <div class="itemHeading" style="color: #005f32">{{ festivalHolidays.length }}</div>
                    </v-flex>
                    <v-flex xs2 sm3 md3 lg3 text-center>
                      <v-icon color="#005f32" size="50px">
                        mdi-calendar-heart
                      </v-icon>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 pl-2 pb-2>
                <v-card class="pa-6 elevation-1" rounded="lg" @click="teamMembersDialog = true"
                  style="cursor: pointer;">
                  <v-layout wrap justify-start align-center>
                    <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                      <div>Team Members</div>
                      <div class="itemHeading" style="color: #005f32">{{ teamMembers.length }}</div>
                    </v-flex>
                    <v-flex xs2 sm3 md3 lg3 text-center>
                      <v-icon color="#005f32" size="50px">
                        mdi-account-group
                      </v-icon>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
     
        <v-layout wrap justify-center mt-5>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg" @click="lateComingsDialog = true" style="cursor: pointer;">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Late Comings ({{ currentMonth }})</div>
                  <div class="itemHeading" style="color: #005f32">{{ lateComings }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-clock-alert-outline
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg" @click="leavesTakenDialog = true" style="cursor: pointer;">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Leaves Taken ({{ currentMonth }})</div>
                  <div class="itemHeading" style="color: #005f32">{{ leavesTaken }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-calendar-blank-outline
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Last Year CL ({{ lastYearPeriod }})</div>
                  <div class="itemHeading" style="color: #005f32">{{ leavesBalance.lastYearCL }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-calendar-check
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Current Year CL ({{ currentYearPeriod }})</div>
                  <div class="itemHeading" style="color: #005f32">{{ leavesBalance.currentYearCL }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-calendar-check
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg" @click="leaveConsumedDialog = true" style="cursor: pointer;">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Leave Consumed ({{ currentYearPeriod }})</div>
                  <div class="itemHeading" style="color: #005f32">{{ leavesBalance.leaveConsumed }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-calendar-remove
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Leave Balance ({{ currentYearPeriod }})</div>
                  <div class="itemHeading" style="color: #005f32">{{ leavesBalance.leaveBalance }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-calendar-plus
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 lg4 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg" @click="importantDatesDialog = true" style="cursor: pointer;">
              <v-layout wrap justify-start align-center>
                <v-flex text-left xs10 sm9 md9 lg9 class="itemHeading">
                  <div>Important Dates</div>
                  <div class="itemHeading" style="color: #005f32">{{ importantDates.length }}</div>
                </v-flex>
                <v-flex xs2 sm3 md3 lg3 text-center>
                  <v-icon color="#005f32" size="50px">
                    mdi-calendar-star
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12 pa-2>
            <v-card class="pa-6 elevation-1" rounded="lg">
              <v-date-picker v-model="dates" multiple full-width readonly no-title color="#005f32"
                class="mt-4"></v-date-picker>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog persistent v-model="dialog" max-width="600px">
        <v-card>
          <v-layout wrap>
            <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
              <v-layout wrap>
                <v-flex xs6 align-self-center text-left>
                  <span class="kumbhBold" style="color: #ffffff; font-size: 20px">Invalid Location</span>
                </v-flex>
                <v-flex xs6 align-self-center text-right>
                  <v-btn icon color="white" text @click="dialog = false">
                    <v-icon color="#ffffff">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 pa-4></v-flex>
            <v-flex xs12>
              <v-layout wrap px-5 pb-8>
                <v-flex xs12 align-self-center text-left>
                  <span class="kumbhBold" style="color: #000; font-size: 20px">Please enable location access and try
                    again</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- <v-flex xs12 py-12>
        <v-layout wrap justify-center>
          <v-flex xs12 align-self-center lg4 pa-2 v-for="(item,i) in dummy" :key="i">
            <v-card color="#EEEECE" elevation="3" class="rounded-xl" outlined height="120px">
              <v-layout wrap justify-center fill-height>
                <v-flex xs9 align-self-center pa-2>
                  <span class="popsemibold">
                    {{ item.text }}
                  </span>
                </v-flex>
                <v-flex xs3 pa-2 align-self-center>
                  <span style="font-size:38px;color:red" class="popsemibold">
                    {{ item.count }}
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex> -->
    </v-layout>

    <v-dialog persistent v-model="remarkdialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">Remarks</span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="remarkdialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pt-2>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="itemValue"> Description</span>
                <v-textarea class="pt-2 text-des" style="font-size: 14px" v-model="description" outlined dense
                  hide-details></v-textarea>
              </v-flex>

              <v-flex pt-2 xs12 align-self-center text-left>
                <span class="itemValue"> Upload Images</span>
                <v-layout wrap justify-center pa-5 style="border: solid 1px">
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs12 sm6 md4 lg4 pa-5 v-for="(items, index) in displayImage" :key="index">
                        <v-img :src="items" fill-height height="100%" width="100%">
                          <v-layout wrap>
                            <v-flex text-right pa-0>
                              <v-avatar color="#FF3434" size="15">
                                <v-icon color="#FFF" small @click="removeImage(index)">
                                  mdi-close
                                </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-end>
                      <v-flex xs12 text-right>
                        <v-btn color="blue-grey" dark small @click="$refs.uploadDoc.click()" class="itemform"><span>
                            UPLOAD
                            IMAGES </span>
                          <v-icon right dark> mdi-cloud-upload </v-icon></v-btn>
                      </v-flex>
                      <input v-show="false" id="file1" ref="uploadDoc" multiple type="file"
                        accept=".svg, .png, .jpg, .jpeg" @change="uploadDoc" />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pb-3>
            <v-btn color="#005f32" @click="submitRemark()">
              <span class="itemValue" style="color: white"> Submit </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="remarkdialogedit" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">Edit Notes</span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="remarkdialogedit = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pt-2>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left v-if="attendanceData">
                <span class="itemValue"> Description</span>
                <v-textarea class="pt-2 text-des" style="font-size: 14px" v-model="attendanceData.description" outlined
                  dense hide-details></v-textarea>
              </v-flex>

              <v-flex pt-2 xs12 align-self-center text-left v-if="attendanceData">
                <span class="itemValue"> Images</span>
                <v-layout wrap justify-center pa-5 style="border: solid 1px" v-if="attendanceData.photos">
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs12 sm6 md4 lg4 pa-5 v-for="(items, index) in attendanceData.photos" :key="index">
                        <v-img :src="mediaURL + items" fill-height height="100%" width="100%">
                          <v-layout wrap>
                            <v-flex text-right pa-0>
                              <v-avatar color="#FF3434" size="15">
                                <v-icon color="#FFF" small @click="
                                  (deleteDialogImage = true),
                                  (imgItem = items)
                                  ">
                                  mdi-close
                                </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <!-- <v-layout wrap justify-end>
                      <v-flex xs12 text-right>
                        <v-btn color="blue-grey" dark small @click="$refs.uploadDoc.click()" class="itemform"><span>
                            UPLOAD IMAGES </span>
                          <v-icon right dark> mdi-cloud-upload </v-icon></v-btn>
                      </v-flex>
                      <input v-show="false" id="file1" ref="uploadDoc" multiple type="file"
                        accept=".svg, .png, .jpg, .jpeg" @change="uploadDoc" />
                    </v-layout> -->
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex pt-2 xs12 align-self-center text-left>
                <span class="itemValue"> Upload Images</span>
                <v-layout wrap justify-center pa-5 style="border: solid 1px">
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs12 sm6 md4 lg4 pa-5 v-for="(items, index) in displayImage" :key="index">
                        <v-img :src="items" fill-height height="100%" width="100%">
                          <v-layout wrap>
                            <v-flex text-right pa-0>
                              <v-avatar color="#FF3434" size="15">
                                <v-icon color="#FFF" small @click="removeImage(index)">
                                  mdi-close
                                </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-end>
                      <v-flex xs12 text-right>
                        <v-btn color="blue-grey" dark small @click="$refs.uploadDoc.click()" class="itemform"><span>
                            UPLOAD
                            IMAGES </span>
                          <v-icon right dark> mdi-cloud-upload </v-icon></v-btn>
                      </v-flex>
                      <input v-show="false" id="file1" ref="uploadDoc" multiple type="file"
                        accept=".svg, .png, .jpg, .jpeg" @change="uploadDoc" />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pb-3>
            <v-btn color="#005f32" @click="editSubmitRemark()">
              <span class="itemValue" style="color: white"> Submit </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="teamMembersDialog" persistent max-width="800px" max-height="600px">
      <v-card>
        <v-card-title class="elevation-0" style="background-color: #005f32; color: white;">
          <span class="kumbhBold" style="font-size: 20px;">
            Team Members
          </span>
          <v-spacer></v-spacer>
          <v-btn icon color="white" text @click="teamMembersDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap v-if="teamMembers.length > 0">
            <v-flex xs12>
              <v-simple-table class="align-center">
                <template v-slot:default>
                  <thead style="background-color: #005f32">
                    <tr>
                      <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Name
                      </th>
                      <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Location
                      </th>
                    </tr>
                  </thead>
                  <tbody class="align-center">
                    <tr class="text-left align-center" v-for="(member, i) in teamMembers" :key="i">
                      <td><span style="font-family: kumbhMedium">{{ member.name || 'N/A' }}</span></td>
                      <td><span style="font-family: kumbhMedium">{{ member.location || 'N/A' }}</span></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap v-else>
            <v-flex xs12 align-self-center pa-16 text-center>
              <span class="kumbhRegular">No team members found!</span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Work Anniversary Dialog -->
    <v-dialog v-model="workAnniversaryDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-party-popper</v-icon>
                  Work Anniversary
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="workAnniversaryDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="workAnniversary.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-calendar-blank</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No work anniversaries today</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in workAnniversary" :key="index" class="mb-3 elevation-2" rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Date of Joining: {{ formatDate(employee.dateofjoining) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-briefcase</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ calculateYears(employee.dateofjoining) }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Latest Employee Dialog -->
    <v-dialog v-model="latestEmployeeDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-multiple-plus</v-icon>
                  Newly Joined Employees
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="latestEmployeeDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="latestEmployeeList.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-off</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No new employees</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in latestEmployeeList" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Date of Joining: {{ formatDate(employee.dateofjoining) }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Last Resigned Dialog -->
    <v-dialog v-model="lastResignedDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-multiple-minus</v-icon>
                  Last Resigned Employees
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="lastResignedDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="lastResignedList.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-off</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No resigned employees</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in lastResignedList" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Last Working Day: {{ formatDate(employee.lastWorkingDay) }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Birthday Dialog -->
    <v-dialog v-model="birthdayDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-cake-variant</v-icon>
                  Employee Birthdays
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="birthdayDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 sm6 md4 pr-2 pb-4>
                <v-select
                  v-model="birthdayFilterMonth"
                  :items="probationMonths"
                  label="Select Month"
                  @change="getBirthdayList($event)"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 v-if="dialogBirthdayList.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-cake-variant-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No birthdays for the selected month</div>
              </v-flex>

              <v-flex xs12 v-else>
                <div v-if="todaysBirthdays.length > 0">
                  <div class="kumbhBold mb-3" style="font-size: 18px; color: #005f32;">Birthday Today</div>
                  <v-card v-for="(employee, index) in todaysBirthdays" :key="'today-'+index" class="mb-3 elevation-2" rounded="lg" style="border: 2px solid #005f32;">
                    <v-layout wrap pa-4 align-center>
                      <v-flex xs12 sm2 text-center>
                        <v-avatar color="#005f32" size="60">
                          <v-icon color="white" size="35">mdi-account</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                        <v-layout wrap>
                          <v-flex xs12>
                            <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                              {{ employee.name }}
                            </span>
                          </v-flex>
                          <v-flex xs12 pt-2>
                            <v-layout align-center>
                              <v-icon small color="#005f32" class="mr-2">mdi-cake-variant</v-icon>
                              <span class="itemValue" style="color: #666;">
                                Date of Birth: {{ formatDate(employee.dob) }}
                              </span>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 pt-1>
                            <v-layout align-center>
                              <v-icon small color="#005f32" class="mr-2">mdi-gift</v-icon>
                              <span class="itemValue" style="color: #666;">
                                🎉 Wishing a very Happy Birthday! 🎉
                              </span>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </div>

                <div v-if="upcomingBirthdaysInMonth.length > 0">
                  <div v-if="todaysBirthdays.length > 0" class="kumbhBold mb-3 mt-5" style="font-size: 18px; color: #005f32;">Birthdays this Month</div>
                  <v-card v-for="(employee, index) in upcomingBirthdaysInMonth" :key="'upcoming-'+index" class="mb-3 elevation-2" rounded="lg">
                    <v-layout wrap pa-4 align-center>
                      <v-flex xs12 sm2 text-center>
                        <v-avatar color="#005f32" size="60">
                          <v-icon color="white" size="35">mdi-account</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                        <v-layout wrap>
                          <v-flex xs12>
                            <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                              {{ employee.name }}
                            </span>
                          </v-flex>
                          <v-flex xs12 pt-2>
                            <v-layout align-center>
                              <v-icon small color="#005f32" class="mr-2">mdi-cake-variant</v-icon>
                              <span class="itemValue" style="color: #666;">
                                Date of Birth: {{ formatDate(employee.dob) }}
                              </span>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="festivalDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-calendar-heart</v-icon>
                  Upcoming Holidays
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="festivalDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="festivalHolidays.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-calendar-blank</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No upcoming festivals</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(festival, index) in festivalHolidays" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-calendar-heart</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ festival.festivalName }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ formatDate(festival.festivalDate) }} ({{ festival.festivalDay }})
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-office-building</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Office {{ festival.isOfficeOpen ? 'Open' : 'Closed' }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="onTimeDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-timer-check-outline</v-icon>
                  On Time Employees ({{ filteredOnTimeEmployees.length }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="onTimeDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 px-5 pt-4 pb-2>
             <v-select v-model="onTimeFilter" :items="locationFilterOptions" label="Filter by Staff Type" dense outlined hide-details></v-select>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="filteredOnTimeEmployees.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-timer-off-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No on-time employees</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in filteredOnTimeEmployees" :key="index" class="mb-3 elevation-2" rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-clock-time-eight</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Punch In: {{ formatDateTime(employee.punchInTime) }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="lateDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-clock-alert-outline</v-icon>
                  Late Arrival Employees ({{ filteredLateEmployees.length }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="lateDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 px-5 pt-4 pb-2>
             <v-select v-model="lateFilter" :items="locationFilterOptions" label="Filter by Staff Type" dense outlined hide-details></v-select>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="filteredLateEmployees.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-clock-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No late arrivals</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in filteredLateEmployees" :key="index" class="mb-3 elevation-2" rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-clock-time-eight</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Punch In: {{ formatDateTime(employee.punchInTime) }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- Add this new dialog for Present Employees after the existing dialogs (e.g., after the lateDialog) -->
    <v-dialog v-model="presentDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-check-outline</v-icon>
                  Present Employees ({{ filteredPresentEmployees.length }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="presentDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 px-5 pt-4 pb-2>
             <v-select v-model="presentFilter" :items="locationFilterOptions" label="Filter by Staff Type" dense outlined hide-details></v-select>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="filteredPresentEmployees.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-off</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No present employees today</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in filteredPresentEmployees" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Add this new dialog for On Leave Employees after the presentDialog -->
    <v-dialog v-model="onLeaveDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-remove-outline</v-icon>
                  Employees On Leave ({{ filteredOnLeaveEmployees.length }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="onLeaveDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 px-5 pt-4 pb-2>
             <v-select v-model="onLeaveFilter" :items="locationFilterOptions" label="Filter by Staff Type" dense outlined hide-details></v-select>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="filteredOnLeaveEmployees.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-off</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No employees on leave today</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in filteredOnLeaveEmployees" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="milestoneDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-trophy</v-icon>
                  Upcoming Milestones
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="milestoneDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="milestones.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-trophy-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No upcoming milestones</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(milestone, index) in milestones" :key="index" class="mb-3 elevation-2" rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ milestone.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-trophy</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ milestone.milestone }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Joining Date: {{ formatDate(milestone.joining_date) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-gift</v-icon>
                            <span class="itemValue" style="color: #666;">
                              🎉 Celebrating {{ milestone.milestone }} with the organization! 🎉
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ageGroupDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs8 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-group</v-icon>
                  Employees in Age Group {{ currentAgeGroup }}
                </span>
              </v-flex>
              <v-flex xs4 align-self-center text-right>
                <v-btn icon color="white" text @click="ageGroupDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="ageGroupEmployees.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-off</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No employees in this age group</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in ageGroupEmployees" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-cake-variant</v-icon>
                            <span class="itemValue" style="color: #666;">
                              DOB: {{ formatDate(employee.dob) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-account</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Age: {{ employee.age }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteDialogImage" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Delete Image</span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="deleteDialogImage = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px">Are you sure you want to delete this
                  Image?</span>
              </v-flex>

              <v-flex xs11 align-self-center text-right pt-3>
                <v-btn @click="deleteImage(imgItem)" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Delete </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="probationDialog" max-width="800px" max-height="600px">
      <v-card>
        <v-card-title class="elevation-0" style="background-color: #005f32; color: white;">
          <span class="kumbhBold" style="font-size: 20px;">
            Employees {{ probationType === 'on-probation' ? 'On Probation' : 'Confirmed' }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon color="white" text @click="probationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap v-if="probationEmployees.length > 0">
            <v-flex xs12>
              <v-simple-table class="align-center">
                <template v-slot:default>
                  <thead style="background-color: #005f32">
                    <tr>
                      <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Name
                      </th>
                      <!-- <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Department</th> -->
                      <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Join
                        Date</th>
                    </tr>
                  </thead>
                  <tbody class="align-center">
                    <tr class="text-left align-center" v-for="(emp, i) in probationEmployees" :key="i">
                      <td><span style="font-family: kumbhMedium">{{ emp.name || 'N/A' }}</span></td>
                      <!-- <td><span style="font-family: kumbhMedium">{{ emp.department || 'N/A' }}</span></td> -->
                      <td><span style="font-family: kumbhMedium">{{ formatDate(emp.dateofjoining) }}</span></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap v-else>
            <v-flex xs12 align-self-center pa-16 text-center>
              <span class="kumbhRegular">No employees found!</span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Important Dates Dialog -->
    <v-dialog v-model="importantDatesDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-calendar-star</v-icon>
                  Important Dates
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="importantDatesDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="importantDates.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-calendar-star-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No important dates found</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(date, index) in importantDates" :key="index" class="mb-3 elevation-2" rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-calendar-star</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ date.title || 'Important Date' }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ formatDate(date.date) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1 v-if="date.description">
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-information</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ date.description }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Upcoming Probation Clearance Dialog -->
    <v-dialog v-model="upcomingProbationDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-clock</v-icon>
                  Upcoming Probation Review
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="upcomingProbationDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 sm6 md4 pr-2 pb-4>
                <v-select
                  v-model="probationFilterMonth"
                  :items="probationMonths"
                  label="Select Month"
                  @change="getUpcomingProbationClearance"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-flex>
              
              <v-flex xs12 v-if="upcomingProbationClearanceList.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-clock-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No upcoming probation review found for the selected month</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(employee, index) in upcomingProbationClearanceList" :key="index" class="mb-3 elevation-2" rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-account</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ employee.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar-check</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Probation Ends: {{ formatDate(employee.dateofProbationCompletion) }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Leave Consumed Dialog -->
    <v-dialog v-model="leaveConsumedDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-calendar-remove</v-icon>
                  Leave Consumed ({{ currentYearPeriod }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="leaveConsumedDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="leaveConsumedFinancialYear.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-calendar-remove-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No leave records found for this financial year</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(leave, index) in leaveConsumedFinancialYear" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-calendar-remove</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            Leave Date
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ formatDate(leave.date) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-clock-time-eight</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Type: {{ leave.type }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-adjust</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Category: {{ leave.category }}
                            </span>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Late Comings Dialog -->
    <v-dialog v-model="lateComingsDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-clock-alert-outline</v-icon>
                  Late Comings ({{ currentMonth }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="lateComingsDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="lateComingsDetails.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-clock-alert-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No late comings found for this month</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(coming, index) in lateComingsDetails" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-clock-alert-outline</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            Late Coming
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Date: {{ formatDate(coming.create_date) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-clock-time-eight</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Time: {{ coming.time || coming.checkInTime || 'N/A' }}
                            </span>
                          </v-layout>
                        </v-flex> -->
                        <!-- <v-flex xs12 pt-1 v-if="coming.lateBy">
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-timer-sand</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Late by: {{ coming.lateBy }}
                            </span>
                          </v-layout>
                        </v-flex> -->
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Leaves Taken Dialog -->
    <v-dialog v-model="leavesTakenDialog" max-width="700px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-calendar-blank-outline</v-icon>
                  Leaves Taken ({{ currentMonth }})
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="leavesTakenDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="leavesTakenDetails.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-calendar-blank-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No leaves taken found for this month</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-card v-for="(leave, index) in leavesTakenDetails" :key="index" class="mb-3 elevation-2"
                  rounded="lg">
                  <v-layout wrap pa-4 align-center>
                    <v-flex xs12 sm2 text-center>
                      <v-avatar color="#005f32" size="60">
                        <v-icon color="white" size="35">mdi-calendar-blank-outline</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 sm10 pl-sm-4 pt-3 pt-sm-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="kumbhBold" style="font-size: 18px; color: #005f32;">
                            {{ leave.type || 'Leave' }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ formatDate(leave.date) }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-adjust</v-icon>
                            <span class="itemValue" style="color: #666;">
                              {{ leave.category || 'Nil' }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12 pt-2>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-calendar</v-icon>
                            <span class="itemValue" style="color: #666;">
                              From: {{ formatDate(leave.startDate) }} - To: {{ formatDate(leave.endDate) }}
                            </span>
                          </v-layout>
                        </v-flex> -->
                        <!-- <v-flex xs12 pt-1>
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-counter</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Days: {{ leave.days || leave.duration || 'N/A' }}
                            </span>
                          </v-layout>
                        </v-flex> -->
                        <!-- <v-flex xs12 pt-1 v-if="leave.reason">
                          <v-layout align-center>
                            <v-icon small color="#005f32" class="mr-2">mdi-information</v-icon>
                            <span class="itemValue" style="color: #666;">
                              Reason: {{ leave.reason }}
                            </span>
                          </v-layout>
                        </v-flex> -->
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Gender Distribution Dialog -->
    <v-dialog v-model="genderDistributionDialog" max-width="800px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-group</v-icon>
                  Employee Gender Details
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="genderDistributionDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="genderDistributionList.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-group</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No employees found</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-simple-table class="align-center">
                  <template v-slot:default>
                    <thead style="background-color: #005f32">
                      <tr>
                        <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Name</th>
                        <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Age</th>
                        <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Date of Birth</th>
                      </tr>
                    </thead>
                    <tbody class="align-center">
                      <tr class="text-left align-center" v-for="(employee, i) in genderDistributionList" :key="i">
                        <td><span style="font-family: kumbhMedium">{{ employee.name || 'N/A' }}</span></td>
                        <td><span style="font-family: kumbhMedium">{{ employee.age || 'N/A' }}</span></td>
                        <td><span style="font-family: kumbhMedium">{{ formatDate(employee.dob) }}</span></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Staff Distribution Dialog -->
    <v-dialog v-model="staffDistributionDialog" max-width="800px">
      <v-card style="position: relative; z-index: 1000;">
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  <v-icon color="white" class="mr-2">mdi-account-group-outline</v-icon>
                  Staff Distribution Details
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="staffDistributionDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4>
            <v-layout wrap px-5>
              <v-flex xs12 v-if="staffDistributionList.length === 0" text-center py-8>
                <v-icon size="80" color="grey lighten-1">mdi-account-group-outline</v-icon>
                <div class="mt-4 itemValue" style="color: grey;">No staff found</div>
              </v-flex>

              <v-flex xs12 v-else>
                <v-simple-table class="align-center">
                  <template v-slot:default>
                    <thead style="background-color: #005f32">
                      <tr>
                        <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Name</th>
                        <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Age</th>
                        <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Date of Birth</th>
                      </tr>
                    </thead>
                    <tbody class="align-center">
                      <tr class="text-left align-center" v-for="(employee, i) in staffDistributionList" :key="i">
                        <td><span style="font-family: kumbhMedium">{{ employee.name || 'N/A' }}</span></td>
                        <td><span style="font-family: kumbhMedium">{{ employee.age || 'N/A' }}</span></td>
                        <td><span style="font-family: kumbhMedium">{{ formatDate(employee.dob) }}</span></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import store from "../../store";
// import Analytics from "./analytics";
// import GraphData from "./graphData";
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    // Analytics,
    // GraphData,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      imgItem: "",
      selectedGrowthChunk: '',
      growthChunkOptions: [],
      pastDataDialog: false,
      pastDataForm: {
        financialYear: '',
        count: null
      },
      deleteDialogImage: false,
      remarkdialog: false,
      remarkdialogedit: false,
      workAnniversaryDialog: false,
      dates: [],
      birthdayDialog: false,
      latestEmployeeDialog: false,
      lastResignedDialog: false,
      onTimeDialog: false,
      onTimeEmployees: [],
      editItem: "",
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      probationEmployees: [],
      probationDialog: false,
      probationType: '',
      timeout: 5000,
      msg: null,
      dashboard: {},
      presentDialog: false,
      presentEmployees: [],
      onLeaveDialog: false,
      onLeaveEmployees: [],
      ageGroupDialog: false,
      ageGroupEmployees: [],
      currentAgeGroup: '',
      rangeMap: {
        "20-35": 1,
        "36-45": 2,
        "46-59": 3,
        "59+": 4
      },
      workAnniversary: [],
      employeeName: '',
      birthdayList: [],
      latestEmployeeList: [],
      lastResignedList: [],
      onTimeArrivals: 0,
      myWorkAnniversary: { month: '', date: '' },
      lateArrivals: 0,
      profile: {},
      isLoggedout: false,
      isLoggedin: false,
      value1: "",
      arr: [],
      loginTime: "",
      logoutTime: "",
      hr: "",
      hrs: "",
      hourValue: "",
      visible: false,
      level: "",
      dummy: [
        {
          text: "ANIMAL LIVES SAVED",
          count: 90,
        },
        {
          text: "AREA OF NATURAL HABITAT SECURED",
          count: 24,
        },
        {
          text: "THREATENED SPECIES RECOVERED",
          count: 26,
        },
        {
          text: "ELEPHANTS SAVED FROM TRAIN COLLISIONS",
          count: 46,
        },
        {
          text: "ENFORCEMENT OPERATIONS TO DISMANTLE WILDLIFE TRADE AND TRAFFICKING",
          count: 30,
        },
        {
          text: "FOREST GUARDS TRAINED AS A PART OF VAN RAKSHAK PROJECT",
          count: 177,
        },
        {
          text: "FAMILIES ENABLED WITH GREEN LIVELIHOODS, REDUCING DEPENDENCE ON WILDLIFE",
          count: 200,
        },
        {
          text: "NUMBER OF CHILDREN MADE AWARE OF CONSERVATION",
          count: 266,
        },
      ],
      lat: null,
      lon: null,
      note: "",
      address: "",
      maps: "",
      state: "",
      city: "",
      loc: "",
      currentdate: new Date().toDateString(),
      dialog: false,
      description: "",
      atndnce: [],

      docs1: [],
      docs1Public: [],
      docsPublic: [],
      docs: [],
      displayImage: [],
      userList: [],
      userArray: [],
      newArray: [],
      selectedFilter: "Today", // Default filter
      filterOptions: ["Today", "Last 7 days", "Last 30 days", "Last 60 days", "Last 90 days"],
      selectedFilter1: "present",
      filters: [
        { text: "Present", value: "present" },
        { text: "Leave", value: "leave" },
        { text: "Absent", value: "absent" }
      ],
      doc: null,
      file: null,
      keyword: "",
      registerAssets: {},
      formData: new FormData(),
      assetId: "",
      search: "",
      Rules: [(value) => !!value || "Required."],
      fileArray: [],
      byte: "",
      kb: "",
      mb: "",
      gb: "",
      attendanceData: {},
      graph: [],
      flag: false,
      probationFlag: false,
      ageDistributionFlag: false,
      genderDistributionFlag: false,
      staffDistributionFlag: false,
      series: [
        {
          name: "Users",
          data: [],
        },
      ],
      probationSeries: [
        {
          name: "Employees",
          data: [],
        },
      ],
      ageDistributionSeries: [
        {
          name: "Employees",
          data: [],
        },
      ],
      genderDistributionSeries: [
        {
          name: "Employees",
          data: [],
        },
      ],
      staffDistributionSeries: [
        {
          name: "Employees",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [], // X-axis categories (Financial Years)
          labels: {
            rotate: -45,
            rotateAlways: true,
            style: {
              fontSize: '10px',
              fontFamily: 'kumbhRegular'
            }
          },
          title: {
            text: "Financial Year", // X-axis Label
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          title: {
            text: "Employees", // Y-axis Label
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return +val;
            },
          },
        },
        colors: ["#005f32"],
        responsive: [
          {
            breakpoint: 600,
            options: {
              xaxis: {
                labels: {
                  fontSize: '8px',
                  rotate: -45,
                }
              },
              chart: {
                height: 300
              }
            }
          }
        ]
      },
      probationChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          events: {
            click: (event, chartContext, config) => {
              this.handleProbationBarClick(event, chartContext, config);
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "30%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["On Probation", "Confirmed"],
          title: {
            text: "Number of Employees",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          title: {
            text: "Employee Status",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " employees";
            },
          },
        },
        colors: ["#005f32"],
      },
      // ageDistributionChartOptions: {
      //   chart: {
      //     type: "bar",
      //     height: 350,
      //   },
      //   plotOptions: {
      //     bar: {
      //       horizontal: true,
      //       barHeight: "30%",
      //       endingShape: "rounded",
      //     },
      //   },
      //   dataLabels: {
      //     enabled: true,
      //     style: {
      //       fontSize: '14px',
      //       fontWeight: 'bold',
      //       colors: ['#fff']
      //     }
      //   },
      //   stroke: {
      //     show: true,
      //     width: 2,
      //     colors: ["transparent"],
      //   },
      //   xaxis: {
      //     categories: ["20-35", "36-45", "46-59", "59+"],
      //     title: {
      //       text: "Number of Employees",
      //       style: {
      //         fontSize: '14px',
      //         fontWeight: 'bold'
      //       }
      //     }
      //   },
      //   yaxis: {
      //     title: {
      //       text: "Age Group",
      //       style: {
      //         fontSize: '14px',
      //         fontWeight: 'bold'
      //       }
      //     }
      //   },
      //   fill: {
      //     opacity: 1,
      //   },
      //   tooltip: {
      //     y: {
      //       formatter: function (val) {
      //         return val + " employees";
      //       },
      //     },
      //   },
      //   colors: ["#005f32"],
      // },
      genderDistributionChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          events: {
            click: (event, chartContext, config) => {
              this.handleGenderBarClick(event, chartContext, config);
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "30%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["Male", "Female"],
          title: {
            text: "Number of Employees",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          title: {
            text: "Gender",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " employees";
            },
          },
        },
        colors: ["#005f32"],
      },
      staffDistributionChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          events: {
            click: (event, chartContext, config) => {
              this.handleStaffBarClick(event, chartContext, config);
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "30%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["HQ Staff", "Field Staff"],
          title: {
            text: "Number of Employees",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          title: {
            text: "Staff Type",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " employees";
            },
          },
        },
        colors: ["#005f32"],
      },
selectedYear: (new Date().getMonth() < 3) 
              ? `${new Date().getFullYear() - 1}-${new Date().getFullYear()}` 
              : `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`,      years: this.getYears(),
      festivalHolidays: [],
      festivalDialog: false,
      lateComings: 0,
      leavesTaken: 0,
      lateDialog: false,
      lateEmployees: [],
      milestoneDialog: false,
      milestones: [],
      teamMembers: [],
      teamMembersDialog: false,
      importantDates: [],
      importantDatesDialog: false,
      birthdayFilterMonth: new Date().getMonth() + 1,
      dialogBirthdayList: [],
      upcomingProbationClearanceList: [],
      upcomingProbationDialog: false,
      probationFilterMonth: new Date().getMonth() + 1,
      probationFilterYear: new Date().getFullYear(),
      probationMonths: [
        { text: 'January', value: 1 },
        { text: 'February', value: 2 },
        { text: 'March', value: 3 },
        { text: 'April', value: 4 },
        { text: 'May', value: 5 },
        { text: 'June', value: 6 },
        { text: 'July', value: 7 },
        { text: 'August', value: 8 },
        { text: 'September', value: 9 },
        { text: 'October', value: 10 },
        { text: 'November', value: 11 },
        { text: 'December', value: 12 },
      ],
      leaveConsumedFinancialYear: [],
      leaveConsumedDialog: false,
      lateComingsDetails: [],
      lateComingsDialog: false,
      leavesTakenDetails: [],
      leavesTakenDialog: false,
      genderDistributionList: [],
      genderDistributionDialog: false,
      staffDistributionList: [],
      staffDistributionDialog: false,
      leavesBalance: {
        lastYearCL: 0,
        currentYearCL: 0,
        leaveConsumed: 0,
        leaveBalance: 0
      },
      leaveBalanceFY: (new Date().getMonth() < 3) 
              ? `${new Date().getFullYear() - 1}-${new Date().getFullYear()}` 
              : `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`,
      dashboardFyears: this.getYears(),
      presentFilter: 'All',
      onLeaveFilter: 'All',
      onTimeFilter: 'All',
      lateFilter: 'All',
      locationFilterOptions: ['All', 'HQ', 'Field'],
    };
  },
  computed: {
    filteredPresentEmployees() {
      if (this.presentFilter === 'All') return this.presentEmployees;
      return this.presentEmployees.filter(e => (e.staffType || '').trim().toUpperCase() === this.presentFilter.toUpperCase());
    },
    filteredOnLeaveEmployees() {
      if (this.onLeaveFilter === 'All') return this.onLeaveEmployees;
      return this.onLeaveEmployees.filter(e => (e.staffType || '').trim().toUpperCase() === this.onLeaveFilter.toUpperCase());
    },
    filteredOnTimeEmployees() {
      if (this.onTimeFilter === 'All') return this.onTimeEmployees;
      return this.onTimeEmployees.filter(e => (e.staffType || '').trim().toUpperCase() === this.onTimeFilter.toUpperCase());
    },
    filteredLateEmployees() {
      if (this.lateFilter === 'All') return this.lateEmployees;
      return this.lateEmployees.filter(e => (e.staffType || '').trim().toUpperCase() === this.lateFilter.toUpperCase());
    },
    appLogin() {
      if (store.state.isLoggedIn) this.getProfile();
      return store.state.isLoggedIn;
    },
    position() {
      return localStorage.getItem("positionId");
    },
    todaysBirthdays() {
      const today = new Date();
      return this.dialogBirthdayList.filter(employee => {
        if (!employee.dob) return false;
        const doj = new Date(employee.dob);
        return doj.getDate() === today.getDate() && doj.getMonth() === today.getMonth();
      });
    },
    upcomingBirthdaysInMonth() {
      const today = new Date();
      return this.dialogBirthdayList.filter(employee => {
        if (!employee.dob) return false;
        const doj = new Date(employee.dob);
        return !(doj.getDate() === today.getDate() && doj.getMonth() === today.getMonth());
      });
    },
    currentYearPeriod() {
      return this.leaveBalanceFY;
    },
    lastYearPeriod() {
      if (!this.leaveBalanceFY) return '';
      const parts = this.leaveBalanceFY.split('-');
      return `${parseInt(parts[0]) - 1}-${parseInt(parts[0])}`;
    },
    ageDistributionChartOptions() {
      return {
        chart: {
          type: "bar",
          height: 350,
          events: {
            click: (event, chartContext, config) => {
              if (config.seriesIndex === 0) {
                const index = config.dataPointIndex;
                const categories = ["20-35", "36-45", "46-59", "59+"];
                const category = categories[index];
                if (category) {
                  const range = this.rangeMap[category];
                  this.currentAgeGroup = category;
                  this.getAgeGroupEmployees(range);
                  this.ageGroupDialog = true;
                }
              }
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "30%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["20-35", "36-45", "46-59", "59+"],
          title: {
            text: "Number of Employees",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          title: {
            text: "Age Group",
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " employees";
            },
          },
        },
        colors: ["#005f32"],
      }
    },
    currentMonth() {
      return new Date().toLocaleString('default', { month: 'short' });
    },
  },
  beforeMount() {

    if (this.position === "62a2de91ecd959516cd3b0e6") {
      this.generateGrowthChunks();
      this.getEmployeeGrowthGraph();
      this.getDashboardData();
      this.getWorkAnniversary();
      this.getLateArrivalsOnTime();
      this.getBirthdayList();
      this.getProbationGraph();
      this.getAgeDistributionGraph();
      this.getGenderDistributionGraph();
      this.getStaffDistributionGraph();
      this.getLatestEmployeeList();
      this.getLastResignedList();
      this.getOnTimeEmployees();
      this.getLateEmployees();
      this.getPresentEmployees();
      this.getOnLeaveEmployees();
      this.getMilestones();
      this.getImportantDates();
      this.getUpcomingProbationClearance();
    } else {
      this.getMyWorkAnniversary();
      this.getFestivalHolidays();
      this.getLateComings();
      this.getLeavesTaken();
      this.getLeavesBalance();
      this.getTeamMembers();
      this.getImportantDates();
      this.getLeaveConsumedFinancialYear();
      this.getLateComingsDetails();
      this.getLeavesTakenDetails();
    }
    this.getProfile();
    this.getGeoLoaction();

  },
  watch: {
    selectedFilter() {
      this.getDashboardData(); // Auto-fetch data when filter changes
      // this.getOnTimeEmployees(); 
      // this.getLateEmployees();
      // this.getPresentEmployees();
      // this.getOnLeaveEmployees();
      // this.getMilestones();
    },
    upcomingProbationDialog(newVal) {
      if (!newVal) {
        const currentMonth = new Date().getMonth() + 1;
        if (this.probationFilterMonth !== currentMonth) {
          this.probationFilterMonth = currentMonth;
          this.getUpcomingProbationClearance();
        }
      }
    },
    birthdayDialog(newVal) {
      if (newVal) {
        this.getBirthdayList(this.birthdayFilterMonth);
      } else {
        const currentMonth = new Date().getMonth() + 1;
        if (this.birthdayFilterMonth !== currentMonth) {
          this.birthdayFilterMonth = currentMonth;
        }
      }
    },
    ageDistributionFlag(newVal) {
      if (newVal && this.$refs.ageChart && this.$refs.ageChart.chart) {
        this.$nextTick(() => {
          const chart = this.$refs.ageChart.chart;
          chart.events.click = (event, chartContext, config) => {
            if (config.seriesIndex === 0) {
              const index = config.dataPointIndex;
              const categories = ["20-35", "36-45", "46-59", "59+"];
              const category = categories[index];
              if (category) {
                const range = this.rangeMap[category];
                this.currentAgeGroup = category;
                this.getAgeGroupEmployees(range);
                this.ageGroupDialog = true;
              }
            }
          };
        });
      }
    }
  },
  methods: {
    clearForm() {
      this.description = "";
      this.displayImage = [];
      this.docs = [];
      this.fileArray = [];
    },
    handleProbationBarClick(event, chartContext, config) {
      if (config.seriesIndex === 0) {
        const index = config.dataPointIndex;
        let type;
        if (index === 0) {
          type = 'on-probation';
        } else if (index === 1) {
          type = 'confirmed';
        }
        if (type) {
          this.probationType = type;
          this.getProbationEmployees(type);
          this.probationDialog = true;
        }
      }
    },
    getProbationEmployees(type) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: `/dashboard/employees?type=${type}`,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.probationEmployees = response.data.data || [];
          } else {
            this.probationEmployees = [];
            this.msg = response.data.msg || 'No data available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.probationEmployees = [];
          console.log(err);
          this.msg = 'Error fetching employees';
          this.showSnackBar = true;
        });
    },
    getAgeGroupEmployees(range) {
      this.appLoading = true;

      axios({
        method: "GET",
        url: `/dashboard/age-distribution-employees/${range}`,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.ageGroupEmployees = response.data.data;
          } else {
            this.ageGroupEmployees = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ageGroupEmployees = [];
          console.log(err);
        });
    },
    getMilestones() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/employee-milestone",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   year: this.year,
        //   filter: this.selectedFilter,  // Pass filter for consistency (adjust if API doesn't support)
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.milestones = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getPresentEmployees() {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/dashboard/attendance-list/today",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          type: "present",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.presentEmployees = response.data.data.presentEmployees || [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getOnLeaveEmployees() {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/dashboard/attendance-list/today",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          type: "on-leave",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.onLeaveEmployees = response.data.data.employeesOnLeave || [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLateEmployees() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/late-employees",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   year: this.year,
        //   filter: this.selectedFilter,  // Pass filter for consistency (adjust if API doesn't support)
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.lateEmployees = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getOnTimeEmployees() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/ontime-employees",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   year: this.year,
        //   filter: this.selectedFilter,  // Pass filter for consistency (adjust if API doesn't support)
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.onTimeEmployees = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getMyWorkAnniversary() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/my-work-anniversary",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.myWorkAnniversary = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getFestivalHolidays() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/festival-leaves",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.festivalHolidays = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLateComings() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/latecoming-this-month",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.lateComings = response.data.data.lateArrivals;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLeavesTaken() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/leaves-taken-this-month",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.leavesTaken = response.data.data.leavesTaken;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLeavesBalance() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/leaves-balance",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          fyear: this.leaveBalanceFY
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.leavesBalance = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getGreeting() {
      const hour = new Date().getHours();
      let greeting;
      if (hour < 12) {
        greeting = 'Good Morning';
      } else if (hour < 17) {
        greeting = 'Good Afternoon';
      } else if (hour < 21) {
        greeting = 'Good Evening';
      } else {
        greeting = 'Good Night';
      }
      // Extract first word from employeeName
      const firstName = this.employeeName ? this.employeeName.split(' ')[0] : '';
      return `${greeting}, ${firstName}!`;
    },
    removeImage(index) {
      this.displayImage.splice(index, 1);
      this.docs.splice(index, 1);
      this.fileArray.splice(index, 1);
    },
    // uploadDoc(event) {
    //   this.docs1 = event.target.files || event.dataTransfer.files;

    //   if (this.docs.length < 10) {
    //     for (let i = 0; i < this.docs1.length; i++) {
    //       if (this.fileArray.includes(this.docs1[i].name)) {
    //         this.msg = "Duplicate File";
    //         this.showSnackBar = true;
    //       } else {
    //         const urls = URL.createObjectURL(this.docs1[i]);
    //         this.displayImage.push(urls);
    //         this.docs.push(this.docs1[i]);
    //         console.log("file", this.docs1[i]);
    //         console.log("haii img", this.docs);
    //       }
    //       this.fileArray.push(this.docs1[i].name);
    //       this.checkbox = false;
    //       // this.checkbox1 = false;
    //       this.checkbox3 = false;
    //       // this.checkbox2 = false;
    //       this.docs1[i].sizeCopy = this.docs1[i].size + "Bytes";
    //       if (this.docs1[i].size >= 1024) {
    //         this.byte = this.docs1[i].size;
    //         this.kb = this.byte / 1024;
    //         if (this.kb >= 1024) {
    //           this.mb = (this.byte / 1048576).toFixed(2);
    //           if (this.mb >= 1024) {
    //             this.gb = (this.byte / 1073741824).toFixed(2);
    //             this.docs1[i].sizeCopy = this.gb + "GB";
    //           } else {
    //             this.docs1[i].sizeCopy = this.mb + "MB";
    //           }
    //         } else {
    //           this.docs1[i].sizeCopy = this.kb.toFixed(2) + "KB";
    //         }
    //       }
    //     }
    //     // this.addToArray();
    //   } else {
    //     this.msg = "Maximum 10 can be uploaded";
    //     this.showSnackBar = true;
    //   }
    // },

    uploadDoc(event) {
      this.docs1 = event.target.files || event.dataTransfer.files;

      if (this.docs.length < 10) {
        for (let i = 0; i < this.docs1.length; i++) {
          if (this.fileArray.includes(this.docs1[i].name)) {
            this.msg = "Duplicate File";
            this.showSnackBar = true;
          } else {
            const urls = URL.createObjectURL(this.docs1[i]);
            this.displayImage.push(urls);
            this.docs.push(this.docs1[i]);
          }
          this.fileArray.push(this.docs1[i].name);
        }
      } else {
        this.msg = "Maximum 10 images can be uploaded";
        this.showSnackBar = true;
      }
    },
    // submitRemark() {
    //   let formData = new FormData();

    //   // Add description to formData
    //   formData.append("description", this.description);
    //   formData.append("attendanceId", this.$route.query.id);

    //   // Add images to formData
    //   for (let i = 0; i < this.docs.length; i++) {
    //     formData.append("photos[]", this.docs[i]);
    //   }

    //   // Make API request to the backend route
    //   this.$axios.post('/attendance/note/update', formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data',
    //         "x-auth-token": localStorage.getItem("token"),
    //       },
    //     })
    //     .then(response => {
    //       // Handle success
    //       console.log("Remark added successfully", response);
    //       this.$emit('close'); // Close dialog if you are emitting an event to close it
    //       this.clearForm();
    //     })
    //     .catch(error => {
    //       // Handle error
    //       console.error("Error adding remark", error);
    //     });
    // },
    submitRemark() {
      let formData = new FormData();

      // formData.append("attendanceId", this.$route.query._id);

      const selectedAttendance = this.atndnce.find(
        (item) => item.attendanceType === "login"
      ); // Adjust condition as needed

      // Get the _id from the selected attendance object
      const attendanceId = selectedAttendance ? selectedAttendance._id : null;
      if (!attendanceId) {
        this.msg = "No matching attendance record found.";
        this.showSnackBar = true;
        return;
      }

      formData.append("description", this.description);
      formData.append("attendanceId", attendanceId);
      for (let i = 0; i < this.docs.length; i++) {
        formData.append("photos", this.docs[i]);
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/attendance/note/update",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: formData, // Use the local formData object, not this.formData
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.clearForm();
            this.showSnackBar = true;
            this.remarkdialog = false;
            this.getProfile();
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSubmitRemark() {
      let formData = new FormData();

      // formData.append("attendanceId", this.$route.query._id);

      const selectedAttendance = this.atndnce.find(
        (item) => item.attendanceType === "login"
      ); // Adjust condition as needed

      // Get the _id from the selected attendance object
      const attendanceId = selectedAttendance ? selectedAttendance._id : null;
      if (!attendanceId) {
        this.msg = "No matching attendance record found.";
        this.showSnackBar = true;
        return;
      }

      formData.append("description", this.attendanceData.description);
      formData.append("attendanceId", attendanceId);
      for (let i = 0; i < this.docs.length; i++) {
        formData.append("photos", this.docs[i]);
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/attendance/note/update",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: formData, // Use the local formData object, not this.formData
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.remarkdialogedit = false;
            this.getProfile();
            this.showSnackBar = true;
            this.description = null;
            this.docs = [];
            this.displayImage = [];
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getDashboardData() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/count/leaves",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.year,
          filter: this.selectedFilter, // Send selected filter
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.dashboard = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getWorkAnniversary() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/work-anniversary",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.year,
          filter: this.selectedFilter, // Send selected filter
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.workAnniversary = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getBirthdayList(month = null) {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      let params = {
        year: this.year,
        filter: this.selectedFilter, // Send selected filter
      };
      if (month) {
        params.month = month;
      }

      axios({
        method: "GET",
        url: "/dashboard/birthday-list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: params,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            if (month) {
              this.dialogBirthdayList = response.data.data;
            } else {
              this.birthdayList = response.data.data;
              this.dialogBirthdayList = response.data.data;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLatestEmployeeList() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/latest-employee-list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.year,
          filter: this.selectedFilter, // Send selected filter
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.latestEmployeeList = response.data.data.list;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLastResignedList() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "/dashboard/last-resigned-list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.year,
          filter: this.selectedFilter, // Send selected filter
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.lastResignedList = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getLateArrivalsOnTime() {
      this.appLoading = true;
      if (!this.year) {
        this.year = new Date().getFullYear();
      }

      axios({
        method: "GET",
        url: "dashboard/latearrivals-ontime",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.year,
          filter: this.selectedFilter, // Send selected filter
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.lateArrivals = response.data.data.lateArrivals;
            this.onTimeArrivals = response.data.data.onTimeArrivals;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getProbationGraph() {
      this.appLoading = true;
      this.probationFlag = false;
      this.probationSeries[0].data = [];

      axios({
        method: "GET",
        url: "/dashboard/probation-graph",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            const probationData = response.data.data;
            this.probationSeries[0].data = [
              probationData.onProbation || 0,
              probationData.confirmed || 0
            ];
            // Ensure categories are set
            this.probationChartOptions.xaxis.categories = ['On Probation', 'Confirmed'];
            this.probationFlag = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getAgeDistributionGraph() {
      this.appLoading = true;
      this.ageDistributionFlag = false;
      this.ageDistributionSeries[0].data = [];

      axios({
        method: "GET",
        url: "/dashboard/age-distribution-graph",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            // Access nested data object
            const ageData = response.data.data;

            // Populate the chart data with age distribution
            this.ageDistributionSeries[0].data = [
              ageData["20-35"] || 0,
              ageData["36-45"] || 0,
              ageData["46-59"] || 0,
              ageData["59+"] || 0
            ];

            console.log("Chart Data:", this.ageDistributionSeries[0].data); // Debug log
            this.ageDistributionFlag = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getGenderDistributionGraph() {
      this.appLoading = true;
      this.genderDistributionFlag = false;
      this.genderDistributionSeries[0].data = [];

      axios({
        method: "GET",
        url: "/dashboard/gender-distribution-graph",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            // Access nested data object
            const genderData = response.data.data;

            // Populate the chart data with gender distribution
            // Note: API returns "emale" which appears to be a typo for "female"
            this.genderDistributionSeries[0].data = [
              genderData.male || 0,
              genderData.emale || genderData.female || 0
            ];

            this.genderDistributionFlag = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getStaffDistributionGraph() {
      this.appLoading = true;
      this.staffDistributionFlag = false;
      this.staffDistributionSeries[0].data = [];

      axios({
        method: "GET",
        url: "/dashboard/staff-distribution-graph",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            // Access nested data object
            const staffData = response.data.data;

            // Populate the chart data with staff distribution
            this.staffDistributionSeries[0].data = [
              staffData.HQStaff || 0,
              staffData.nonHQStaff || 0
            ];

            this.staffDistributionFlag = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getTeamMembers() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/team-members",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.teamMembers = response.data.data || [];
          } else {
            this.teamMembers = [];
            this.msg = response.data.message || 'No data available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.teamMembers = [];
          console.log(err);
          this.msg = 'Error fetching team members';
          this.showSnackBar = true;
        });
    },
    getImportantDates() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/important-dates",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.importantDates = response.data.data || [];
          } else {
            this.importantDates = [];
            this.msg = response.data.message || 'No important dates available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.importantDates = [];
          console.log(err);
          this.msg = 'Error fetching important dates';
          this.showSnackBar = true;
        });
    },
    getUpcomingProbationClearance() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: `/dashboard/upcoming-probation-clearance?month=${this.probationFilterMonth}&year=${this.probationFilterYear}`,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.upcomingProbationClearanceList = response.data.data || [];
          } else {
            this.upcomingProbationClearanceList = [];
            this.msg = response.data.message || 'No data available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.upcomingProbationClearanceList = [];
          console.log(err);
          this.msg = 'Error fetching upcoming probation clearance';
          this.showSnackBar = true;
        });
    },
    getLeaveConsumedFinancialYear() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/leaves-taken-this-financial-year",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.leaveConsumedFinancialYear = response.data.data.leaveDates || [];
          } else {
            this.leaveConsumedFinancialYear = [];
            this.msg = response.data.message || 'No leave data available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.leaveConsumedFinancialYear = [];
          console.log(err);
          this.msg = 'Error fetching leave data';
          this.showSnackBar = true;
        });
    },
    getLateComingsDetails() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/latecoming-this-month-details",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.lateComingsDetails = response.data.data.lateArrivals || [];
          } else {
            this.lateComingsDetails = [];
            this.msg = response.data.message || 'No late coming details available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.lateComingsDetails = [];
          console.log(err);
          this.msg = 'Error fetching late coming details';
          this.showSnackBar = true;
        });
    },
    getLeavesTakenDetails() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/leaves-taken-this-month-details",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.leavesTakenDetails = response.data.data.leaveDates || [];
          } else {
            this.leavesTakenDetails = [];
            this.msg = response.data.message || 'No leaves taken details available';
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.leavesTakenDetails = [];
          console.log(err);
          this.msg = 'Error fetching leaves taken details';
          this.showSnackBar = true;
        });
    },
    handleGenderBarClick(event, chartContext, config) {
      if (config.seriesIndex === 0) {
        const index = config.dataPointIndex;
        let gender;
        if (index === 0) {
          gender = 'Male';
        } else if (index === 1) {
          gender = 'Female';
        }
        if (gender) {
          this.getGenderDistributionList(gender);
        }
      }
    },
    getGenderDistributionList(gender) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: `/dashboard/gender-distribution-list?gender=${gender}`,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.genderDistributionList = response.data.data || [];
            this.genderDistributionDialog = true;
          } else {
            this.genderDistributionList = [];
            this.msg = response.data.message || `No ${gender} employees found`;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.genderDistributionList = [];
          console.log(err);
          this.msg = 'Error fetching gender distribution list';
          this.showSnackBar = true;
        });
    },
    handleStaffBarClick(event, chartContext, config) {
      if (config.seriesIndex === 0) {
        const index = config.dataPointIndex;
        let type;
        if (index === 0) {
          type = 'HQ';
        } else if (index === 1) {
          type = 'Field';
        }
        if (type) {
          this.getStaffDistributionList(type);
        }
      }
    },
    getStaffDistributionList(type) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: `/dashboard/staff-distribution-list?type=${type}`,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.staffDistributionList = response.data.data || [];
            this.staffDistributionDialog = true;
          } else {
            this.staffDistributionList = [];
            this.msg = response.data.message || `No ${type} staff found`;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.staffDistributionList = [];
          console.log(err);
          this.msg = 'Error fetching staff distribution list';
          this.showSnackBar = true;
        });
    },
  getYears() {
  const startYear = 2020;
  const currentYear = new Date().getFullYear();
  // If we are currently in Jan-March, the current FY starts last year
  const currentFYStart = new Date().getMonth() < 3 ? currentYear - 1 : currentYear;
  
  const years = [];
  // Generate up to current FY + 1
  for (let year = startYear; year <= currentFYStart + 1; year++) {
    years.push(`${year}-${year + 1}`);
  }
  return years;
},
    generateGrowthChunks() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      const currentFYEndYear = currentMonth < 3 ? currentYear : currentYear + 1;
      
      const startYear = 1998;
      const options = [];
      let currentChunkStart = startYear;
      
      while (currentChunkStart + 5 <= currentFYEndYear) {
        options.push(`${currentChunkStart}-${currentChunkStart + 5}`);
        currentChunkStart += 5;
      }
      
      if (currentChunkStart < currentFYEndYear) {
        options.push(`${currentChunkStart}-${currentChunkStart + 5}`);
      }
      
      this.growthChunkOptions = options.reverse();
      if (!this.selectedGrowthChunk) {
        this.selectedGrowthChunk = this.growthChunkOptions[0];
      }
    },
    submitPastData() {
      if (!this.pastDataForm.financialYear || !this.pastDataForm.count) {
        this.msg = "Please fill both fields";
        this.showSnackBar = true;
        return;
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/dashboard/employee-growth-past-data",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: {
          financialYear: this.pastDataForm.financialYear,
          count: parseInt(this.pastDataForm.count)
        }
      }).then(response => {
        this.appLoading = false;
        if (response.data.status) {
          this.msg = response.data.message;
          this.showSnackBar = true;
          this.pastDataDialog = false;
          this.pastDataForm = { financialYear: '', count: null };
          this.getEmployeeGrowthGraph();
        }
      }).catch(err => {
        this.appLoading = false;
        console.error(err);
      });
    },
    getEmployeeGrowthGraph() {
      this.appLoading = true;
      this.flag = false;
      
      const startYear = this.selectedGrowthChunk ? this.selectedGrowthChunk.split('-')[0] : '';

      axios({
        method: "GET",
        url: "/dashboard/employee-growth-graph",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { startYear: startYear }
      })
        .then((response) => {
          this.appLoading = false;
          const apiData = response.data.data || [];
          const categories = [];
          const data = [];

          apiData.forEach(item => {
            categories.push(item.financialYear);
            data.push(item.count);
          });

          this.chartOptions.xaxis.categories = categories;
          this.series[0].data = data;
          this.flag = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.error(err);
        });
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/employee/profile/me",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          isAttendance: true,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.profile = response.data;
            this.employeeName = response.data.data.name;
            this.atndnce = response.data.atndnce;
            localStorage.setItem("isloggedin", response.data.isLoggedin);
            this.isLoggedout = response.data.isLoggedout;
            this.isLoggedin = response.data.isLoggedin;
            this.loginTime = response.data.loginTime;
            this.logoutTime = response.data.logoutTime;
            this.attendanceData = this.atndnce.find(
              (item) => item.attendanceType === "login"
            ); // Adjust condition as needed

            // var start = new Date(this.loginTime).getTime() - 5.5 * 60 * 60000;
            // var end = new Date().getTime();
            var start = new Date(this.loginTime).getTime();
            var end = new Date().getTime();
            if (this.logoutTime != "")
              end = new Date(this.logoutTime).getTime();
            // end = new Date(this.logoutTime).getTime() - 5.5 * 60 * 60000;

            var hours = (end - start) / 3600 / 1000;
            console.log("time: ", new Date(this.loginTime), new Date());
            console.log("hours: ", hours);
            this.hr = end - start;
            console.log("ens and start", this.hr);
            // var timespan = 3196683;
            if (this.hr) {
              this.hourValue = this.msToHMS(this.hr);
            } else {
              this.hourValue = 0;
            }
            console.log("result", this.hourValue);
            var newValue = 100 / 8;
            this.value1 = hours * newValue;
            if (this.value1 > 99) {
              this.value1 = 99;
            }
            localStorage.setItem(
              "orgid",
              response.data.data.organisationID._id
            );
            localStorage.setItem("userid", response.data.data._id);
            this.level = response.data.data.level;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getGeoLoaction() {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gettingLocation = false;
          this.location = pos;
          this.lat = this.location.coords.latitude;
          this.lon = this.location.coords.longitude;
          this.getStreetAddressFrom(this.lat, this.lon);
        },
        (err) => {
          this.gettingLocation = false;
          this.errorStr = err.message;
        }
      );
    },
    async getStreetAddressFrom(lat, long) {
      try {
        var { data } = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          long +
          "&key=AIzaSyBpukNl1L1qGqEwad87A1-MkZj8H_bKDZM"
        );
        if (data.error_message) {
          console.log(data.error_message);
        } else {
          // if(data.result[0]){
          this.address = data.results[0].formatted_address;
          //  if(data.result[0].address_components[0]){
          this.loc = data.results[0].address_components[0];
          // for(var i=0; i<this.loc.length;i++){
          //   this.state=this.loc[i].long_name
          // }
          this.state = data.results[0].address_components[2].long_name;
          this.city = data.results[0].address_components[1].long_name;
          console.log("state", this.state);
          console.log("city", this.city);

          //  }
          // }
        }
      } catch (error) {
        console.log(error.message);
      }
    },
    submit(item) {
      console.log("data", item, " lon", this.lon, "lat", this.lat);
      if (!this.lon || !this.lat) {
        this.dialog = true;
      } else {
        axios({
          method: "POST",
          url: "/attendance/mark",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            // description: this.note,
            attendanceType: item,
            lon: this.lon,
            lat: this.lat,
            city: this.city,
            state: this.state,
            address: this.address,
            isWebsite: true,
          },
        })
          .then((response) => {
            if (response.data.status) {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.getProfile();
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((e) => {
            this.visible = false;
            this.errors.push(e);
            this.msg = "failed";
          });
      }
    },
    formatAMPM(time) {
      if (!time) return;
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    msToHMS(ms) {
      var seconds = ms / 1000;
      var hrs = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
      hrs = hrs < 10 ? "0" + hrs : hrs;
      seconds = seconds % 3600; // seconds remaining after extracting hrs
      var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds % 60;
      return hrs + " : " + minutes;
    },
    convertUTCToLocal(utcDateString) {
      // Create a new Date object from the UTC date string
      var utcDate = new Date(utcDateString);
      const hours = utcDate.getHours();
      const minutes = utcDate.getMinutes().toString().padStart(2, "0");
      const amPm = hours >= 12 ? "PM" : "AM";

      // Adjust hours for 12-hour format (convert from 24-hour to 12-hour)
      const adjustedHours = hours % 12 || 12;

      // Format the time string (HH:MM AM/PM)
      const formattedTime = `${adjustedHours}:${minutes} ${amPm}`;

      // Return the date and time as separate objects
      return formattedTime;
    },
    // deleteImage(imgItem) {
    //   this.appLoading = true;
    //   const selectedAttendance = this.atndnce.find(
    //     (item) => item.attendanceType === "login"
    //   ); // Adjust condition as needed

    //   // Get the _id from the selected attendance object
    //   const attendanceId = selectedAttendance ? selectedAttendance._id : null;
    //   if (!attendanceId) {
    //     this.msg = "No matching attendance record found.";
    //     this.showSnackBar = true;
    //     return;
    //   }

    //   axios({
    //     method: "POST",
    //     url: "/attendance/photo/delete",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     data: {
    //       attendanceId: attendanceId,
    //       photo: imgItem,
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status) {
    //         this.appLoading = false;
    //         this.getProfile();
    //         this.showSnackBar = true;
    //         this.deleteDialogImage = false;

    //         //this.getData();
    //       } else {
    //         this.appLoading = false;
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //       }
    //     })
    //     .catch((err) => {
    //       // store.commit("appLoading", false);
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    deleteImage(imgItem) {
      this.appLoading = true;

      axios({
        method: "POST",
        url: "/resource/image/delete/single",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          photo: imgItem,    // image being deleted
          id: this.imgItemId // id of the item containing the image
        },
      })
        .then((response) => {
          if (response.data.status) {
            // Remove the deleted image from the editingitem.photo array
            this.editingitem.photo = this.editingitem.photo.filter(
              (photo) => photo !== imgItem
            );

            this.appLoading = false;
            this.showSnackBar = true;
            this.deleteDialogImage = false;
            this.getData(); // Optionally refresh the data from the server
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },

    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
      const timeOptions = { hour: '2-digit', minute: '2-digit' };
      const formattedDate = date.toLocaleDateString('en-US', dateOptions);
      const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
      return `${formattedDate} at ${formattedTime}`;
    },

    calculateYears(dateString) {
      if (!dateString) return 'N/A';
      const joinDate = new Date(dateString);
      const today = new Date();
      let years = today.getFullYear() - joinDate.getFullYear();
      const monthDiff = today.getMonth() - joinDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < joinDate.getDate())) {
        years--;
      }

      if (years === 0) {
        return 'Celebrating first work anniversary!';
      } else if (years === 1) {
        return 'Celebrating 1 year with the organization';
      } else {
        return `Celebrating ${years} years with the organization`;
      }
    },

  },
};
</script>

<style scoped>
.pa-6.elevation-1 {
  background-color: rgb(220, 252, 202) !important;
}
</style>